import { Box, Typography, Container } from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigation } from "../../hooks/useNavigation";

import { projectData } from "../../compontents/project/ProjectData";
import { normalize, fetchProjectByTitle, findAdjacentProjects } from "../../utils/Utilities";
import FormatText from '../../utils/formatting/TextFormatter';

import ErrorPage from "../error/ErrorPage";

export default function SingleProjectPage() {
    const { title } = useParams();
    const { goProjects, goWorkProjects } = useNavigation();

    const project = fetchProjectByTitle(title);
    if (!project) return <ErrorPage />;

    const handleGoToProjects = () => {
        goProjects();
    };

    const handleToSingleProject = (title: string) => {
        goWorkProjects(title);
    };


    const currentIndex = projectData.findIndex(p => normalize(p.title) === title);
    const adjacentProjects = currentIndex !== -1 ? findAdjacentProjects(currentIndex, projectData) : [];

    const projectImages = [project.image, project.altimage];
    
    return (
        <Box
            sx={{
                position: 'relative',
                paddingTop: "70px",
                paddingBottom: "80px",
                width: "100%",
                height: "100%",
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                pb: '75px',
                zIndex: 3,
                backgroundColor: "#111111;"
            }}
        >

            <Box sx={{ maxWidth: { sm: 'auto', md: '730px', lg: '1208px' }, width: '100%' }}>
                <Container sx={{paddingX: { xs: 2, sm: 5, md: 0 }}}>
                    <FormatText 
                        key={title}
                        sections={project.content} 
                        url={title} 
                    />
                </Container>
                
                <Container maxWidth="lg" sx={{ pt: '40px', pb: '80px' }}>
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr 1fr",
                                sm: "1fr 1fr",
                                md: "1fr 1fr 1fr 1fr"
                            },
                            gap: { xs: 2, sm: 3, md: 4 },
                            textAlign: "left",
                            justifyItems: "center",
                            width: "100%",
                            mt: -1,
                            mb: 4,
                        }}
                    >
                        {Object.entries(project.moreInfo[0]).map(([key, value]) => (
                            <Box
                                key={key}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-start',
                                    justifyContent: 'flex-start',
                                    minHeight: { xs: '120px', sm: '140px', md: '160px' },
                                    width: '100%',
                                    borderRadius: 2,
                                    p: 2,
                                }}
                            >
                                <Typography sx={{ fontSize: { xs: "16px", md: "18px" }, mb: 1, color: 'gray' }}>
                                    {key}
                                </Typography>
                                <Typography sx={{ fontSize: { xs: "16px", md: "18px" }, mt: 1, color: 'white', wordBreak: 'break-word' }}>
                                    {String(value)}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Container>

                <Container>
                    {projectImages.map((img, index) => (
                        <Box
                            key={index}
                            component="img"
                            src={img}
                            alt=""
                            sx={{
                                display: 'block',
                                position: 'relative',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '100%',
                                maxWidth: {
                                    sm: '100%',
                                    md: '730px',
                                    lg: '1208px',
                                },
                                height: {
                                    xs: '240px',
                                    md: '440px',
                                    lg: '648px',
                                },
                                objectFit: 'cover',
                                mb: 3,
                                borderRadius: '8px',
                            }}
                        />
                    ))}
                </Container>

                <Container sx={{padding: '80px 0 0', paddingX: { xs: 2, sm: 5, md: 0 }}}>
                    <Typography sx={{ fontSize: '16px', color: 'white', mb: 1, padding: '0px 0px 16px', textAlign: 'left' }}>
                        RELATED PROJECTS
                    </Typography>
                    
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                md: "1fr 1fr 1fr"
                            },
                            
                            textAlign: "left",
                            justifyItems: "center",
                            width: "100%",
                            height: "100%",
                            mt: -1,
                            gap: '24px',
                        }}
                    >
                    {adjacentProjects.map((s, i) => (
                            <Box
                                key={i}
                                role="button"
                                onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        handleToSingleProject(normalize(s.title));
                                    }
                                }}
                                tabIndex={0}
                                aria-label={`Open project: ${s.title}`}
                                sx={{
                                    width: '100%',
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    position: 'relative',
                                    transition: 'transform 0.4s ease',
                                    borderRadius: '8px',
                                    '&:hover .related-image': {
                                        transform: 'scale(1.1)',
                                    },
                                    '&:hover .overlay-bg': {
                                        opacity: 1,
                                    },
                                }}
                                onClick={() => handleToSingleProject(normalize(s.title))}
                                className="tab-indictor"
                            >
                                <Box
                                    component="img"
                                    src={s.image}
                                    alt=""
                                    className="related-image"
                                    sx={{
                                        display: 'block',
                                        width: '100%',
                                        height: '100%',
                                        maxHeight: {
                                            xs: '240px',
                                            md: '160px',
                                            lg: '280px',
                                        },
                                        objectFit: 'cover',
                                        transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                    }}
                                />

                                <Box
                                    className="overlay-bg"
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        maxWidth: {
                                            xs: '100%',
                                            md: '730px',
                                            lg: '1208px',
                                        },
                                        height: '100%',
                                        maxHeight: {
                                            xs: '240px',
                                            md: '160px',
                                            lg: '280px',
                                        },
                                        opacity: 0,
                                        transition: 'opacity 0.4s ease',
                                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                                        zIndex: 2,
                                        pointerEvents: 'none',
                                    }}
                                />
                            </Box>
                        ))}
                    </Box>
                </Container>
                
                <Box sx={{display: 'flex', justifyContent: 'center', mt: 4, mb: 8}}>
                    <Typography
                        tabIndex={0} 
                        role="button"
                        aria-label={"View All Projects"}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleGoToProjects();
                            }
                        }}
                        sx={{
                            fontSize: { xs: '16px', lg: '22px' },
                            color: 'white',
                            mt: 6,
                            mb: 2,
                            alignItems: 'center',
                            textAlign: 'center',
                            cursor: 'pointer',
                            borderBottom: '2px solid white',
                            paddingBottom: '4px',
                            display: 'inline-block', 
                        }}
                        onClick={() => handleGoToProjects()}
                        className="tab-indictor"
                        >
                        View All Projects
                    </Typography>
                </Box>
            </Box> 
        </Box>
    );
}